/* OTERVANO — approved Nuevas imagenes / matching V3 templates.
   Preserves the VETA pilot layout and interaction. Reuses the native variant
   response: no extra fetch, cart, inventory, catalog or carousel mutations. */
(() => {
  'use strict';
  if (customElements.get('ov-veta-copy-gallery')) return;
  class VetaCopyGallery extends HTMLElement {
    connectedCallback() {
      const match = /^ov-lab-([a-z]+)-v3$/.exec(this.dataset.template || '');
      if (!match || this.dataset.scope !== 'approved-copy' || !this.dataset.product || this.dataset.model !== match[1] || (this.dataset.handle !== `${match[1]}-nuevas-imagenes` && this.dataset.handle !== match[1])) return;
      queueMicrotask(() => {
        if (!this.isConnected) return;
        this.bindView();
        this.unsubscribe?.();
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, payload => this.onVariant(payload));
        }
      });
    }
    disconnectedCallback() {
      this.unsubscribe?.(); this.unsubscribe = null;
      this.viewAbort?.abort(); this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.scrollFrame); cancelAnimationFrame(this.resizeFrame);
    }
    bindView() {
      this.viewAbort?.abort(); this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.scrollFrame); cancelAnimationFrame(this.resizeFrame);
      this.viewAbort = new AbortController();
      const opts = {signal:this.viewAbort.signal};
      this.track = this.querySelector('[data-ovvc-track]');
      this.slides = [...this.querySelectorAll('[data-ovvc-media]')];
      this.thumbs = this.querySelector('[data-ovvc-thumbnails]');
      if (!this.track || this.slides.length !== 8) return;
      this.index = 0;
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button || !this.contains(button)) return;
        if (button.hasAttribute('data-ovvc-target')) {
          const i = this.slides.findIndex(slide => slide.dataset.ovvcMedia === button.dataset.ovvcTarget);
          if (i >= 0) this.select(i);
        } else if (button.hasAttribute('data-ovvc-step')) {
          this.select(this.index + Number(button.dataset.ovvcStep));
        }
      }, opts);
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track || event.altKey || event.ctrlKey || event.metaKey) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault(); this.select(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        } else if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault(); this.select(event.key === 'Home' ? 0 : 7);
        }
      }, opts);
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = requestAnimationFrame(() => {
          if (!this.isConnected || !this.track.clientWidth) return;
          const distances = this.slides.map(slide => Math.abs(this.offset(slide) - this.track.scrollLeft));
          this.paint(distances.indexOf(Math.min(...distances)), false);
        });
      }, {...opts, passive:true});
      this.track.scrollLeft = 0;
      if (this.thumbs) this.thumbs.scrollLeft = 0;
      this.paint(0, false);
      this.lastWidth = this.track.clientWidth;
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => {
          const width = this.track?.clientWidth || 0;
          if (!width || Math.abs(width-this.lastWidth) < 1) return;
          this.lastWidth = width;
          cancelAnimationFrame(this.resizeFrame);
          this.resizeFrame = requestAnimationFrame(() => {
            if (this.isConnected && this.slides[this.index]) this.track.scrollTo({left:this.offset(this.slides[this.index]),behavior:'instant'});
          });
        });
        this.resizeObserver.observe(this.track);
      }
      this.dataset.ready = 'true';
    }
    offset(slide) { return slide.offsetLeft - this.slides[0].offsetLeft; }
    select(requested) {
      if (!this.track || !this.slides.length) return;
      const index = Math.max(0, Math.min(this.slides.length-1, requested));
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.paint(index, true);
      this.track.scrollTo({left:this.offset(this.slides[index]),behavior:reduced?'instant':'smooth'});
    }
    paint(index, announce) {
      this.index = index;
      this.slides.forEach((slide,i) => slide.classList.toggle('is-active',i===index));
      const buttons = [...this.querySelectorAll('[data-ovvc-target]')];
      buttons.forEach((button,i) => {
        if (i===index) button.setAttribute('aria-current','true');
        else button.removeAttribute('aria-current');
      });
      const prev = this.querySelector('[data-ovvc-step="-1"]');
      const next = this.querySelector('[data-ovvc-step="1"]');
      if (prev) prev.disabled = index===0;
      if (next) next.disabled = index===this.slides.length-1;
      const counter = this.querySelector('[data-ovvc-current]');
      if (counter) counter.textContent = String(index+1);
      if (announce) {
        const live = this.querySelector('[data-ovvc-status]');
        if (live) live.textContent = `Foto ${index+1} de ${this.slides.length}.`;
        const button = buttons[index];
        if (button && this.thumbs) {
          const rect = button.getBoundingClientRect(), bounds = this.thumbs.getBoundingClientRect();
          if (rect.left < bounds.left) this.thumbs.scrollLeft -= bounds.left-rect.left+4;
          else if (rect.right > bounds.right) this.thumbs.scrollLeft += rect.right-bounds.right+4;
        }
      }
    }
    onVariant(payload) {
      try {
        const data = payload?.data;
        if (!this.isConnected || String(data?.sectionId) !== this.dataset.section || !data?.html || !data?.variant) return;
        const source = data.html.getElementById(this.id);
        if (!source || source.localName !== 'ov-veta-copy-gallery' || source.dataset.product !== this.dataset.product || source.dataset.template !== this.dataset.template || source.dataset.scope !== 'approved-copy') return;
        if (String(data.variant.id) !== source.dataset.variant || source.querySelectorAll('[data-ovvc-media]').length !== 8) return;
        const modal = document.getElementById(`ProductModal-${this.dataset.section}`);
        const sourceModal = data.html.getElementById(`ProductModal-${this.dataset.section}`);
        const sourceContent = sourceModal?.querySelector('.product-media-modal__content');
        const modalContent = modal?.querySelector('.product-media-modal__content');
        if (modal?.hasAttribute('data-ovvc-modal') && sourceContent && modalContent) {
          modal._ovDetail?.close();
          modalContent.innerHTML = sourceContent.innerHTML;
        }
        this.innerHTML = source.innerHTML;
        this.dataset.variant = source.dataset.variant;
        this.bindView();
      } catch (error) {
        console.warn('[OTERVANO V3] No se pudo actualizar la galería:',error.message);
      }
    }
  }
  customElements.define('ov-veta-copy-gallery',VetaCopyGallery);
})();
